module.exports = __webpack_public_path__ + "static/img/极客公园.5ee1a4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/极客公园.svg
// module id = I7Sx
// module chunks = 1